import { ReCaptchaProvider, ReCaptchaProviderProps } from 'next-recaptcha-v3';

interface LazyReCaptchaProviderProps extends ReCaptchaProviderProps {
  load: boolean;
}

const LazyReCaptchaProvider: React.FC<LazyReCaptchaProviderProps> = ({
  children,
  load = false,
  ...props
}) => {
  return (
    <ReCaptchaProvider {...props} defer={!load}>
      {children}
    </ReCaptchaProvider>
  );
};

export default LazyReCaptchaProvider;
